import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';

/**
 * Risolutore del testo informativo per le icone info dei campi.
 * Riceve un `id_info` e ritorna il testo da mostrare nel popup.
 *
 * L'engine resta disaccoppiato dalla sorgente dati: l'app fornisce
 * l'implementazione (es. una chiamata HTTP) tramite questo token.
 * Se non fornito, le icone info non vengono mostrate.
 */
export type FieldInfoResolver = (infoId: number) => Observable<string>;

export const FIELD_INFO_RESOLVER = new InjectionToken<FieldInfoResolver>('FIELD_INFO_RESOLVER');
